import { useState, useContext, MouseEvent, Fragment } from 'react';
import { dropJWT, getJWTDecoded } from '../../helpers/helpers';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import CommentIcon from '@mui/icons-material/Comment';
import AuthContextValue from '../../models/AuthContextValue';
import { AuthContext } from '../../AuthContext';
import { useMediaQuery } from 'react-responsive';
import AdultOnly from '../shared/AdultOnly';

export default function ProfileDropdown() {
  const { googleAuth } = useContext<AuthContextValue>(AuthContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const avatarOpen = Boolean(anchorEl);
  const isMobile = useMediaQuery({ query: '(max-width: 985px)' });
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await googleAuth?.signOut();
    dropJWT();
  }

  const userInfo = getJWTDecoded();
  const userName = `${userInfo.firstName} ${userInfo.lastName}`;

  return (
    <Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={isMobile ? {} : { ml: 2 }}
            aria-controls={avatarOpen ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={avatarOpen ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>{userName[0]}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={avatarOpen}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={true}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleClose}>
          <Avatar /> {userName}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
        <AdultOnly>
          <Divider />
          <MenuItem onClick={handleClose}>
            <a href="mailto:feedback@pbeej.com">
              <ListItemIcon sx={{ display: 'inline-block' }}>
                <CommentIcon fontSize="small" />
              </ListItemIcon>
              <span className={'cursor-pointer'}>Give Feedback</span>
            </a>
          </MenuItem>
        </AdultOnly>
      </Menu>
    </Fragment>
  )
}
